import a from "./index4.js";
import { resolveComponent as s, openBlock as l, createElementBlock as d, createVNode as r, withCtx as p, createElementVNode as t, pushScopeId as c, popScopeId as u } from "vue";
import "./index5.js";
import g from "../../../../_virtual/index.js";
const m = (o) => (c("data-v-176fa18e"), o = o(), u(), o), f = { class: "expired-session-dialog" }, C = /* @__PURE__ */ m(() => /* @__PURE__ */ t("p", null, "You have been signed out. To continue your session, sign in.", -1));
function _(o, n, h, k, v, S) {
  const i = s("dialog-layout");
  return l(), d("div", f, [
    r(i, {
      isOpen: o.showDialog,
      variant: o.DialogVariants.ATTENTION,
      title: "Signed Out"
    }, {
      default: p(() => [
        C,
        t("div", null, [
          t("button", {
            class: "action-button sign-in",
            onClick: n[0] || (n[0] = (...e) => o.handleSignInButtonClick && o.handleSignInButtonClick(...e))
          }, " Sign in "),
          t("button", {
            class: "action-button cancel",
            onClick: n[1] || (n[1] = (...e) => o.handleCancelButtonClick && o.handleCancelButtonClick(...e))
          }, " Don't sign in ")
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "variant"])
  ]);
}
const E = /* @__PURE__ */ g(a, [["render", _], ["__scopeId", "data-v-176fa18e"]]);
export {
  E as default
};
//# sourceMappingURL=index3.js.map
